var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [].concat(_vm.appClasses()) },
    [
      _vm.noResults
        ? _c("div", { staticClass: "text-center content-container" }, [
            _c("h4", [_vm._v("You have not added any favourites")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "article-list__items article-list-js" },
        _vm._l(_vm.filteredData, function(item, index) {
          return _c(
            "article-list-item",
            {
              key: item.id,
              class: [
                "article-list__item",
                { "last-item": index === _vm.operators.length - 1 },
                { "proud-member": item.operator_data.is_proud_member == true }
              ],
              attrs: { item: item }
            },
            [
              _c("template", { slot: "details" }, [
                item.operator_data.address
                  ? _c("p", { staticClass: "address" }, [
                      _vm._v(_vm._s(item.operator_data.address))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                item.operator_data.phone
                  ? _c("p", { staticClass: "phone" }, [
                      _vm._v(_vm._s(item.operator_data.phone))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "button" },
                [
                  item.operator_data.email
                    ? _c(
                        "a",
                        {
                          staticClass: "btn email",
                          attrs: {
                            href: "mailto:" + item.operator_data.email,
                            "data-print-text": item.operator_data.email
                          }
                        },
                        [_vm._v("Email")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.operator_data.website
                    ? _c(
                        "a",
                        {
                          staticClass: "btn web",
                          attrs: {
                            href: item.operator_data.website,
                            target: "_blank",
                            "data-print-text": item.operator_data.website
                          }
                        },
                        [_vm._v("Web")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  item.operator_data.phone
                    ? _c(
                        "a",
                        {
                          staticClass: "btn call",
                          attrs: {
                            href: "tel:" + item.operator_data.phone,
                            "data-print-text": item.operator_data.phone
                          }
                        },
                        [_vm._v("Call")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("btn-favourites", {
                    attrs: { postId: item.id },
                    on: {
                      "click:addtofavourites": function($event) {
                        return _vm.favouritesBtnClicked($event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("template", { slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "remove-from-favourites-btn",
                    on: {
                      click: function($event) {
                        return _vm.removeFromFavourites(item.id)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                      [
                        _c("line", {
                          attrs: {
                            stroke: "#fff",
                            "stroke-width": "1",
                            x1: "0",
                            x2: "100%",
                            y1: "0",
                            y2: "100%"
                          }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            stroke: "#fff",
                            "stroke-width": "1",
                            x1: "100%",
                            x2: "0",
                            y1: "0",
                            y2: "100%"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "load-more-wrapper" }, [
        _vm.isLoading ? _c("div", { staticClass: "loader" }) : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.isLoading && _vm.operatorsWithMarkers.length > 0
        ? _c("operator-map", { attrs: { operatorData: _vm.filteredData } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.noResults
        ? _c("div", { staticClass: "share-container" }, [
            _c(
              "button",
              {
                staticClass: "social-share-button",
                on: {
                  click: function($event) {
                    _vm.shareModalActive = true
                  }
                }
              },
              [_vm._v("Share")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("favourites-share", {
        attrs: {
          "modal-open": _vm.shareModalActive,
          "share-url": _vm.shareUrl
        },
        on: { updateModal: _vm.updateShareModal }
      }),
      _vm._v(" "),
      !_vm.isLoading && _vm.filteredData.length > 0
        ? _c("footer", { staticClass: "article-links" }, [
            _c(
              "button",
              {
                staticClass: "print-button",
                attrs: { onclick: "window.print(); return false;" }
              },
              [_vm._v("Print List")]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/Favourites.vue?vue&type=template&id=fbed8cc4&
// module id = 167
// module chunks = 6